module.exports = __webpack_public_path__ + "img/mk-megaphone.9d077c5.png";